import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-695d6823"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "music" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭/播放背景音乐")
const _hoisted_5 = { class: "bgConfig" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("背景设置")
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "userInfo" }
const _hoisted_9 = { class: "inputPwd" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_11 = { class: "bottom" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buttomTop" }, "系统锁屏，请输入密码登录", -1))
const _hoisted_13 = { class: "buttomButtom" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("退出重新登录")
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "lockScreen",
    style: _normalizeStyle({backgroundImage:_ctx.backgroundImage})
  }, [
    _createElementVNode("img", {
      src: _ctx.defaultPic,
      class: "fixImg"
    }, null, 8, _hoisted_1),
    _createElementVNode("audio", {
      src: _ctx.backMusic,
      loop: "",
      autoplay: "",
      ref: el=>_ctx.refMap.set('musicPlayRef',el)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.utilInst.musicEvent())),
        type: "text",
        style: {"color":"#EE6600"}
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.picDialogVisible=true)),
        type: "text"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "content",
      style: _normalizeStyle({marginTop: _ctx.marginTop+'px'})
    }, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.nowTime), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userInfo.usercode), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            placeholder: "请输入密码按回车登录",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.utilInst.lockLogin()), ["enter","native"])),
            ref: el=>_ctx.refMap.set('pwdRef',el),
            type: "password"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.utilInst.lockLogin()))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.utilInst.lockLoginOut()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ], 4),
    _createVNode(_component_el_dialog, {
      title: "选择素材",
      modelValue: _ctx.picDialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.picDialogVisible) = $event)),
      width: "40%",
      draggable: "",
      "show-close": false,
      "close-on-click-modal": false,
      "element-loading-text": "拼命加载中...",
      "append-to-body": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.picDialogVisible=!_ctx.picDialogVisible))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.utilInst.picDialogSure()))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_card, { style: {"height":"260px","overflow-y":"scroll"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageSource.arrayPath, (item) => {
              return (_openBlock(), _createBlock(_component_el_image, {
                key: item.path,
                src: item.path,
                lazy: "",
                style: {"cursor":"pointer","width":"100%"},
                onClick: ($event: any) => (_ctx.utilInst.imgClick(item)),
                class: _normalizeClass(_ctx.selImage(item))
              }, null, 8, ["src", "onClick", "class"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 4))
}